import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Fade } from '@clds/transitions';
import { modalTheme } from '../theme.js';
const Overlay = styled.div `
  position: fixed;
  z-index: -1;
  inset: 0;
  background-color: ${modalTheme.overlay.background};
`;
// eslint-disable-next-line react/display-name
export const Backdrop = forwardRef(({ open, ...rest }, ref) => {
    return (_jsx(Fade, { in: open, timeout: 300, children: _jsx(Overlay, { ...rest, ref: ref }) }));
});
